/**
 * Locale catalogs shipped by `@afassoftware/components`. `setLocale` rejects with
 * "Locale not supported" for anything outside this list, so the page language is
 * resolved against it before the call.
 */
const SUPPORTED_LOCALES = [
  "nl",
  "nl-BE",
  "en",
  "de",
  "es",
  "fr",
  "it",
  "pap",
  "pl",
  "pt",
] as const;

export type AfasLocale = (typeof SUPPORTED_LOCALES)[number];

/** The locale the AFAS component strings are authored in; needs no catalog load. */
export const AFAS_SOURCE_LOCALE: AfasLocale = "nl";

/**
 * Maps the document language (`<html lang>`, written by `_LayoutAiChat` from the
 * request culture) onto a catalog the component package can load. Region variants
 * that have no catalog of their own, such as `nl-NL`, fall back to their base
 * language; anything unrecognised falls back to the source locale.
 */
export function resolveAfasLocale(lang: string | null | undefined): AfasLocale {
  const value = (lang ?? "").trim().toLowerCase();
  if (!value) return AFAS_SOURCE_LOCALE;

  const exact = SUPPORTED_LOCALES.find(
    (locale) => locale.toLowerCase() === value,
  );
  if (exact) return exact;

  const base = value.split("-", 1)[0];
  return (
    SUPPORTED_LOCALES.find((locale) => locale.toLowerCase() === base) ??
    AFAS_SOURCE_LOCALE
  );
}
